import { PaginateQuery, PaginatorModel, UnknownError } from 'symbols';
import { ContractModel, ContractsFilterModel } from '../../symbols';

export class GetContractList {
  static type = '[contractList] GetContractList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<ContractsFilterModel>) {
  }
}

export class GetContractListSuccess {
  static type = '[contractList] GetContractListSuccess';

  constructor(public contractList: PaginatorModel<ContractModel>, public lazy: boolean) {
  }
}

export class GetContractListError {
  static type = '[contractList] GetContractListError';

  constructor(public error: UnknownError) {
  }
}

export class ClearScrollPositionContractList {
  static type = '[contractList] ClearScrollPositionContractList';
}

export class UpdateScrollPositionContractList {
  static type = '[contractList] UpdateScrollPositionContractList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedContractId {
  static type = '[contractList] SetLastOpenedContractId';

  constructor(public contractId: string) {
  }
}
